var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hina-checkbox"},[_c('el-checkbox',_vm._b({on:{"change":_vm.handleChange},model:{value:(_vm.v),callback:function ($$v) {_vm.v=$$v},expression:"v"}},'el-checkbox',_vm.$attrs,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }